import React from "react";
import { AlertBox } from "../../../../../../shared/AlertBox/AlertBox";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import styles from "./styles.module.scss";
import { Input } from "../../../../../../shared/Input/Input";
import { Button } from "../../../../../../shared/Button/Button";
import { CircularProgress } from "../../../../../../shared/CircularProgress/CircularProgress";

export function Otp({
  value,
  onChange,
  onResend,
  isResending,
  sentTo,
  resendCd,
}) {
  const { tAuth: t } = useAppTranslation.Auth({
    keyPrefix: "twoFactor.alternativeOtp",
  });

  return (
    <div className={styles.root}>
      <AlertBox size="small" variant="success">
        {t("success.otpSent", { to: sentTo })}
      </AlertBox>
      <Input
        autoFocus
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("otpPlaceholder")}
      />
      <Button
        size="small"
        variant="text"
        onClick={onResend}
        isDisabled={isResending}
        leftAdornment={isResending ? <CircularProgress size="tiny" /> : null}
      >
        {resendCd > 0 ? `${t("resendIn")} ${resendCd}s` : t("resendOtp")}
      </Button>
    </div>
  );
}
